export default __webpack_public_path__ + "static/media/73.6e0376a7.svg";